<template>
  <div
    :style="{
      backgroundColor: extras.partner ? extras.partner.bg : '#f5f6f7',
    }"
    class="m-partner top-nav"
    v-if="extras.partner.display === 1"
    id="partner"
  >
    <WapTitle
      v-if="extras.partnerTitle.display == 1"
      :title="extras.partnerTitle.model || title"
      :icon="icon"
      :titleFont="extras.partnerTitle.color"
    />
    <div
      v-for="(item1, index) in columns"
      :key="index"
      :class="{ active: index == currentId }"
    >
      <ul class="tab">
        <li class="active">
          {{ item1.name }}
        </li>
      </ul>
      <ul class="tab-body">
        <li
          v-for="(item, index) in item1.article"
          :key="index"

        >
          <div
            class="imgdiv"
            v-if="extras.partnerCover.display == 1"
            @click="detailClick(item)"
          >
            <img
              :src="
                item.coverImageRealPath ||
                require('@/assets/images/defPartner.png')
              "
              alt=""
            />
          </div>
          <div class="title" v-show="extras.partnerContentTitle.display == 1">
          {{ item.name }}
          </div>
          <div class="text" v-show="extras.partnerSummary.display == 1">
          {{ item.desc }}
          </div>
          <!-- <span @click="detailClick(item)">详情</span> -->
        </li>
        <li v-if="item1.article && item1.article.length > 1 && item1.article.length % 2 == 1"></li>
        <div class="no-data" v-if="item1.article && item1.article.length == 0">
          <img :src="require('@/assets/images/nodata.png')" />
          <div class="no-data-text">暂无数据</div>
        </div>
      </ul>
    </div>
    <!--<img-->
    <!--class="more"-->
    <!--v-if="articles && articles.length > 4"-->
    <!--:src="-->
    <!--isShowMore == false-->
    <!--? require('@/assets/images/wap/showmore.png')-->
    <!--: require('@/assets/images/wap/hidemore.png')-->
    <!--"-->
    <!--@click="showMoreArticle"-->
    <!--/>-->
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    WapTitle,
  },
  props: {
    partnerInfo: [],
    extras: Object,
  },
  data() {
    return {
      num: 0,
      title: "合作伙伴",
      icon: require("@/assets/images/wap/huoban.png"),
      columns: [],
      articles: [],
      currentId: 0,
      isShowMore: false,
    };
  },
  created() {
    console.log("wap-partner", this.partnerInfo);
  },
  computed: {
    // columns: function () {
    //   let tempArticles = this.partnerInfo.article;
    //   let tempColumns = this.partnerInfo.column;
    //   const columns = [
    //     {
    //       id: 0,
    //       name: "合作伙伴",
    //       article: tempArticles,
    //     },
    //   ];
    //   for (let item in tempArticles) {
    //     if (item.desc) {
    //       item.desc = item.desc.substr(0, 130);
    //     }
    //   }
    //   for (let i in tempColumns) {
    //     columns.push(tempColumns[i]);
    //   }
    //   return columns;
    // },
    // articles() {
    //   return this.columns[this.currentId].article;
    // },
  },
  mounted() {
    console.log("pc-partner", this.partnerInfo);
    //this.initColumns();

    let tempColumns = this.getColumns.articleInitColumns(
      this.partnerInfo.column,
      this.partnerInfo.article,
      "合作伙伴",
      true
    );
    this.columns = tempColumns;
    this.articles = this.columns[0].article;
  },
  methods: {
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = idx;
      this.articles = item.article;
    },
    ClickDetll(url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      window.open(url);
    },
    detailClick(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (e.linkUrl) {
        window.open(e.linkUrl);
      }
      //
      //      console.log("e", e);
      //      this.$emit("partnerDetailClick", e);
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style lang="scss" scoped></style>
